export default {
  PF: {
    name:'Pessoa Física',
    s1: null,
    s2: null,
    s3: null,
    s4: null
  },
  AGILE: {
    name: 'Agile',
    s1: "Squad",
    s2: "Tribo",
    s3: "Aliança",
    s4: "Diretoria Executiva"
  },
  CORP: {
    name: 'Corporativo',
    s1: "Time",
    s2: "Gerência",
    s3: "Diretoria de Área",
    s4: "C-Level / Diretoria Executiva"
  },
  LITE: {
    name: 'Light',
    s1: "Time",
    s2: "Gerência",
    s3: null,
    s4: null
  },
  REGIONAL:{
    name:'Regional',
    s1: "Time",
    s2: "Setor",
    s3: "Unidade/Loja",
    s4: "Região",
  },
  GOV:{
    name: 'Governamental',
    s1: "Equipe",
    s2: "Divisão",
    s3: "Departamento",
    s4: "Ministério / Secretaria",
  },
  EDU: {
    name: "Educacional",
    s1: "Turma",
    s2: "Curso",
    s3: "Unidade",
    s4: "Região"
  },
  HEALTH: {
    name: "Hospitalar",
    s1: "Equipe",
    s2: "Setor",
    s3: "Unidade/Clínica",
    s4: "Diretoria"
  },
  PMO:{
    name: "PMO",
    s1: "Squad/Time",
    s2: "Projeto",
    s3: "Programa",
    s4: "Portfólio",
  }
}
